import { LazyLoader } from '@bp/ui-components';
import { t } from 'i18next';
import { Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { PlanSchoolEvent } from './PlanSchoolEvent/PlanSchoolEvent';
import { PlanSubstitutions } from './PlanSubstitutions/PlanSubstitutions';
import { PlanTeacherAbsences } from './PlanTeacherAbsences/PlanTeacherAbsences';
import { SubstitutionsPlanPage } from './SubstitutionsPlanPage';
import { SubstitutionsPlanSubpage } from './SubstitutionsPlanSubpage';

export const substitutionPlanRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <SubstitutionsPlanPage />,
    },
    {
      path: t('routes.absences.slug'),
      element: <SubstitutionsPlanSubpage baseSlug={baseSlug} />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.absences.slug')}`,
          title: t('routes.absences.title'),
        }),
      },
      children: [
        {
          element: (
            <Suspense fallback={<LazyLoader transparent forceHeight='40vh' />}>
              <PlanTeacherAbsences />
            </Suspense>
          ),
          index: true,
        },
      ],
    },
    {
      path: t('routes.schoolEvents.slug'),
      element: <SubstitutionsPlanSubpage baseSlug={baseSlug} />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.schoolEvents.slug')}`,
          title: t('routes.schoolEvents.title'),
        }),
      },
      children: [
        {
          element: (
            <Suspense fallback={<LazyLoader transparent forceHeight='40vh' />}>
              <PlanSchoolEvent />
            </Suspense>
          ),

          index: true,
        },
      ],
    },
    {
      path: t('routes.substitutions.slug'),
      element: <SubstitutionsPlanSubpage baseSlug={baseSlug} />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.substitutions.slug')}`,
          title: t('routes.substitutions.title'),
        }),
      },
      children: [
        {
          element: (
            <Suspense fallback={<LazyLoader transparent forceHeight='40vh' />}>
              <PlanSubstitutions />
            </Suspense>
          ),
          index: true,
        },
      ],
    },
  ];
};
